<template>
  <div>
    <el-form ref="form" :model="form" label-width="120px" :rules="validateRules">

      <el-form-item label="方式">
        <el-radio-group v-model="form.type" @change="changeType">
          <el-radio :label="0">添加新邮箱</el-radio>
          <el-radio :label="1">已授权的邮箱</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item prop="name" label="用户名" v-show="form.type === 0">
        <gj-input width="480px" v-model="form.name" placeholder="请输入用户名"></gj-input>
      </el-form-item>

      <el-form-item label="账号">
        <gj-input width="480px" :value="marketItem.marketName" disabled></gj-input>
      </el-form-item>


      <el-form-item label="国家" style="margin-bottom: 0;">
        <gj-input width="480px" :value="getCountry()" disabled></gj-input>

      </el-form-item>

      <el-form-item :show-message="false" class="country-checkbox">
        <el-checkbox-group v-model="form.marketIds" style="width: 480px">
          <template v-if="marketItem.items.filter(v => isMeaningless(v.email)).length> 1">
            <template v-for="(item, index) in marketItem.items">
              <el-checkbox v-if="isMeaningless(item.email)" :key="index" :label="item.id">
                {{ countryMap[item.countryCode] ? countryMap[item.countryCode].text : '-' }}
              </el-checkbox>
            </template>
          </template>
        </el-checkbox-group>
      </el-form-item>

      <template v-if="form.type === 1">
        <el-form-item prop="selectAccount" label="邮箱" style="margin-top: 5px;">
          <gj-select v-model="form.selectAccount" width="480px" :options="accounts" :clearable="false"></gj-select>
        </el-form-item>
      </template>

      <template v-if="form.type === 0">

        <el-form-item label="邮箱类型" style="margin-top: 5px;">
          <gj-select v-model="emailType" width="480px" :options="MarketEnum.emailOption" placeholder="请选则邮箱类型" :clearable="false"></gj-select>
        </el-form-item>

        <el-form-item prop="account" label="邮箱账号" style="margin-top: 5px;margin-bottom: 14px">
          <gj-input @input="inputAccount" v-model="form.account" width="480px" placeholder="亚马逊后台授权服务邮箱账号">
<!--            企业邮箱、手动填写时，没有默认邮箱后缀-->
            <template #append v-if="!['exmail.qq', 'qiye.163', 'qiye.aliyun', 'outlook', 'noMail'].includes(emailType)">
              {{emailTypeInfo.append}}
            </template>
          </gj-input>
        </el-form-item>

        <div class="form-item-info" style="margin-bottom: 10px">
          <a href="http://help.gerpgo.com/web/#/26?page_id=638" target="_blank">如何获取或设置亚马逊邮箱账号？</a>
        </div>

        <el-form-item style="margin-bottom: 14px" prop="authCode" :label="emailTypeInfo.type === 'code'?'授权码':emailTypeInfo.type === 'passWord'?'密码':'密码/授权码'">
          <gj-input
              v-model="form.authCode"
              width="480px"
              :placeholder="emailTypeInfo.type === 'code'?'邮箱授权码非邮箱登录密码':emailTypeInfo.type === 'passWord'?'请输入密码':'根据邮箱要求，密码/授权码二选一填写'"
              type="password">
          </gj-input>
        </el-form-item>

        <div class="form-item-info colorRed" v-if="emailTypeInfo.id === 'Hotmail'">
          提示：Hotmail邮箱非授权码授权，会出现授权成功后又失败的情况，需要重新在邮箱授权中再次授权
        </div>

        <template v-else>
          <div class="form-item-info">查看教程
            <a href="http://help.gerpgo.com/web/#/26?page_id=639" target="_blank">《如何获取邮箱授权码》</a>
          </div>

          <el-form-item style="margin-bottom: 12px;" v-if="emailTypeInfo.id === '126' || emailTypeInfo.id === '163'">
            <template #label>
              <gj-required>额外验证</gj-required>
            </template>
            <div>126，163邮箱需要额外验证，请
              <gj-button @click="hrefValidMail" style="padding: 0" type="text">
                点此链接
              </gj-button>
              进行验证
            </div>
          </el-form-item>
        </template>

        <div style="display: flex">
          <el-form-item style="margin-bottom: 0" prop="imapServer" label="IMAP服务器">
            <gj-input v-model="form.imapServer" width="310px" placeholder="邮箱服务器，在邮箱设置中可获取"></gj-input>
          </el-form-item>
          <gj-checkbox @change="changeSSL" v-model="form.imapSsl" style="margin-left: 10px; padding-top: 6px; margin-right: 10px">
            {{emailType === 'outlook'?'TLS':'SSL'}}
          </gj-checkbox>
          <gj-input width="100px" v-model="form.imapPort"></gj-input>
        </div>

      </template>
    </el-form>
  </div>
</template>

<script>
import {formRuleMixin, isMeaninglessMixin, responseMixin} from "@/minxins";
import {amazonCountryOption} from "@/utils/options";
import {isMeaningful, isMeaningless, transformToMap} from "@/utils/common";
import {bindExistEmail, bindNewEmail, sameSellerEmails} from "@/api/crm";
import {MarketEnum} from "@/views/modules/system/market/enum";
export default {
  name: "mail-authorization",
  mixins: [formRuleMixin, isMeaninglessMixin, responseMixin],
  props: {
    marketItem: null,
    form:{
      type: Object,
      default: function (){
        return {
          name: '',
          type: 1,
          account: null,
          authCode: null,
          marketIds: [],
          imapServer: null,
          imapPort: '993',
          imapSsl: true,
          selectAccount: null,
        }
      }
    }
  },
  created() {
    this.getSameEmails()
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入用户名'))
      }
      if (value && !value.match(/^[a-z0-9A-Z_]{1,}$/)) {
        return callback(new Error('用户名由字母、下划线、数字构成'))
      }

      callback()
    }
    return {
      MarketEnum,
      emailType:'qq',//邮箱类型 用于快速填充IMAP、SSL等
      loading: false,
      rules1: {
        name: [
          {
            required: true,
            validator: validateName,
            trigger: ['blur','change']
          }
        ],
        account: [
          {required: true, message: '请输入邮箱账号', trigger: ['blur','change']}
        ],
        authCode: [
          {required: true, message: '请输入授权码', trigger: ['blur','change']}
        ],
        imapServer: [
          {required: true, message: '请输入服务器', trigger: ['blur','change']}
        ]
      },
      rules2: {
        selectAccount: [
          {required: true, message: '请选择', trigger: ['change', 'blur']}
        ]
      },
      countryMap: transformToMap(amazonCountryOption),
      accounts: null,
    }
  },
  computed: {
    validateRules({ form, rules1, rules2 }) {
      return form.type === 0 ? rules1 : rules2
    },
    // 选中邮件类型 的 相关信息
    emailTypeInfo(){
      return MarketEnum.emailOption.find(r => r.id === this.emailType);
    },
    authCodeRuleStr(){
      return this.emailTypeInfo.type === 'code'?'请输入授权码':this.emailTypeInfo.type === 'passWord'?'请输入密码':'请输入密码/授权码'
    },
  },
  watch:{
    // 选中邮件类型变化时
    emailType:{
      handler(val){
        // 勾选SSL
        this.form.imapSsl = true;
        // 设置SSL
        if(this.emailType === 'outlook'){
          this.form.imapPort = this.emailTypeInfo.TLS;
        }else {
          this.form.imapPort = this.emailTypeInfo.SSL;
        }
        this.rules1.authCode[0].message = this.emailTypeInfo.type === 'code'?'请输入授权码':this.emailTypeInfo.type === 'passWord'?'请输入密码':'请输入密码/授权码'
        // 设置IMAP服务器
        this.form.imapServer = this.emailTypeInfo.IMAP[0];
        this.$nextTick(()=>{
          this.$refs.form.clearValidate('authCode');
          this.$refs.form.clearValidate('imapServer');
        })

      }
    },
    immediate:true
  },
  methods: {
    getSameEmails(){
      if(this.marketItem.marketId){
        sameSellerEmails(this.marketItem.marketId)
            .then((data) => {
              this.accounts = (data || []).map(v => ({id: v, text: v}));
              if(this.accounts.length>0){
                this.form.type=1;
              }else {
                this.form.type=0;
              }
            }).complete(() => {this.$emit('emailsLoading')})
      }else {
        this.$emit('emailsLoading')
      }
    },
    changeType() {
      // console.log(this.marketItem)
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    getCountry() {
      if (this.marketItem.region === 'eu') {
        return '欧洲';
      } else if (this.marketItem.region === 'na') {
        return '北美洲';
      } else {
        return this.countryMap[this.marketItem.countryCode]?this.countryMap[this.marketItem.countryCode].text:'-';
      }
    },
    // SSL勾选状态变化时
    changeSSL(event) {
      if(this.emailType === 'outlook'){
        this.form.imapPort = event ? this.emailTypeInfo.TLS : '143';
      }else {
        this.form.imapPort = event ? this.emailTypeInfo.SSL : '143';
      }

    },
    hrefValidMail() {
      if (isMeaningful(this.form.account)) {
        window.open(`http://config.mail.163.com/settings/imap/login.jsp?uid=${this.form.account+this.emailTypeInfo.append}`,"_blank");
      } else {
        this.$gjMessage.warning('请先输入邮箱账号')
      }
    },
    inputAccount() {
      // if (this.form.account.indexOf('@')) {
      //   if (isMeaningless(this.form.imapPort)) {
      //     this.form.imapPort = '110';
      //   }
      //   const postfix = this.form.account.split('@')[1];
      //   if (postfix === 'qq.com') {
      //     this.form.imapServer = 'imap.qq.com';
      //     this.form.imapPort = '993';
      //     this.form.imapSsl = true;
      //   } else if (postfix === '126.com') {
      //     this.form.imapServer = 'imap.126.com';
      //   } else if (postfix === '163.com') {
      //     this.form.imapServer = 'imap.163.com';
      //   } else if (postfix === 'sina.com') {
      //     this.form.imapServer = 'imap.sina.com';
      //   } else if (postfix === 'aliyun.com') {
      //     this.form.imapServer = 'imap.aliyun.com';
      //   } else if (postfix === 'outlook.com' || postfix === 'hotmail.com') {
      //     this.form.imapServer = 'imap-mail.outlook.com';
      //     this.form.imapPort = '993';
      //     this.form.imapSsl = true;
      //   } else if (postfix === 'gmail.com') {
      //     this.form.imapServer = 'imap.gmail.com';
      //     this.form.imapPort = '993';
      //     this.form.imapSsl = true;
      //   } else if (postfix === '189.cn') {
      //     this.form.imapServer = 'imap.189.cn';
      //     this.form.imapPort = '993';
      //     this.form.imapSsl = true;
      //   }
      //   if (isMeaningful(this.form.imapServer)) {
      //     this.$refs.form.clearValidate('imapServer');
      //   }
      // }
    },
    confirm(fn) {
      if (this.$gjFormValidate()) {
        this.loading = true;
        if (this.form.type === 0) {
          bindNewEmail({...this.form,account:this.form.account+this.emailTypeInfo.append})
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('操作成功');
                  this.$emit('after');
                  if(fn){
                    fn()
                  }
                })
              }).complete(() => this.loading = false)
        } else {
          bindExistEmail({
            account: this.form.selectAccount,
            marketIds: this.form.marketIds,
          })
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('操作成功');
                  this.$emit('after');
                  if(fn){
                    fn()
                  }
                })
              }).complete(() => this.loading = false)
        }
      }
    },

  }
}
</script>

<style scoped lang="scss">

.form-item-info {
  width: 480px;
  padding-left: 120px;
  font-size: 12px;
  margin-bottom: 12px;
}
/deep/ .el-form-item{
  margin-bottom: 18px;
}
/deep/ .gj-modal--custom .el-dialog {
  height: auto !important;
  width: 600px !important;
}

/deep/ .el-checkbox__label {
  font-size: 12px;
}

/deep/ .el-form-item__error {
  position: absolute!important;
}

/deep/ a {
  color: #3582fb;
  text-decoration: none;
}

</style>